export default "__VITE_ASSET__C4EWfk2r__"